import React from "react";
import "../../Trip Details/css/PaymentInformation.css";
import { formatAmount } from "../../../utils/Utils";

const formatMoney = (amount) => formatAmount(Number(amount ?? 0));

const UnregisteredAircraftTripPaymentInformation = ({ tripData }) => {
  const landingFee = Number(tripData?.landingFee ?? 0);
  if (!landingFee) {
    // Hide Payment Information section when landing fee is 0 or null
    return null;
  }

  const subTotal = landingFee;
  const vat = subTotal * 0.1;
  const total = subTotal + vat;

  return (
    <div className="payment-information" data-testid="unregistered-payment-information">
      <p>Payment Information</p>
      <div className="payment-item">
        <div className="payment-info-row">
          <p className="payment-amount pending">
            BSD {formatMoney(total)} <span>(PENDING)</span>
          </p>
        </div>

        <div className="fees">
          {landingFee > 0 && (
            <div className="fee-item">
              <p>Landing Fees</p>
              <div className="fee-amount">$ {formatMoney(landingFee)}</div>
            </div>
          )}
        </div>

        <div className="total-fees">
          <div className="fee-item">
            <p>Sub Total</p>
            <div className="fee-amount">BSD {formatMoney(subTotal)}</div>
          </div>
          <div className="fee-item">
            <p>VAT (10%)</p>
            <div className="fee-amount">BSD {formatMoney(vat)}</div>
          </div>
        </div>

        <div className="total-fees">
          <div className="fee-item">
            <p>Total</p>
            <div className="fee-amount">BSD {formatMoney(total)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnregisteredAircraftTripPaymentInformation;

